import { Link } from 'react-router-dom';
import WebsiteNavbar from './WebsiteNavbar';
import WebsiteFooter from './WebsiteFooter';
import './Website.css';

const sectors = [
  {
    id: '01',
    title: 'Banking & Finance',
    description:
      'Commercial banks, fintechs and microfinance. Covers approved commercial banks in Nigeria plus a fast growing fintech space with over a million subscribers post Covid.',
  },
  {
    id: '02',
    title: 'Telecommunications',
    description:
      'GSM service providers covering telephony, plus Internet Service Providers covering data and internet services.',
  },
  {
    id: '03',
    title: 'Online / E-commerce',
    description:
      'Online shopping, marketplaces and delivery. Evaluates service quality as more citizens embrace online business.',
  },
  {
    id: '04',
    title: 'Insurance & HMO',
    description:
      'General insurance covering traditional policies (car, property, shipping, aviation), plus Health Management Organizations central to health insurance.',
  },
  {
    id: '05',
    title: 'Transportation',
    description:
      'Aviation (air travel), intra-city transport (movement within a city) and inter-state transport (movement between states and major cities).',
  },
  {
    id: '06',
    title: 'Healthcare',
    description:
      'Private health facilities and public health institutions, rated separately for a clear view of service delivery in each.',
  },
  {
    id: '07',
    title: 'Public Sector',
    description:
      'Government ministries, departments and agencies (MDAs), plus Nigerian foreign missions, rating embassies, consulates and high commissions.',
  },
  {
    id: '08',
    title: 'Hospitality',
    description:
      'Hotels, parks and resorts (vacation spots and hangouts), plus eateries, bars, clubs and lounges, rated separately to identify service quality.',
  },
  {
    id: '09',
    title: 'Power',
    description:
      'The distribution segment of the electricity value chain, rating the Distribution Companies (Discos) that serve consumers directly.',
  },
  {
    id: '10',
    title: 'Real Estate',
    description:
      'With major investments and new players entering the ever expanding real estate market in Nigeria, the NCSI covers housing (residential and commercial properties) and the organizations operating in the sector.',
  },
  {
    id: '11',
    title: 'Education',
    description:
      'The NCSI rates only tertiary institutions, sub sectored into two: private and public universities.',
  },
  {
    id: '12',
    title: 'Sports Gaming & Entertainment',
    description:
      'The sports betting industry is a growing market in Nigeria, so rating service delivery amongst betting and gaming organizations is essential. The newest addition to the index.',
  },
];

const WebsiteSectors = () => {
  return (
    <div className="website nx nx-refined">
      <WebsiteNavbar />

      <section className="nx-page-hero">
        <div className="nx-kicker">Coverage</div>
        <h1>Sectors under assessment.</h1>
        <p>Twelve sectors, fully broken down by sub-sector. Select where you received service and submit your assessment.</p>
      </section>

      <section className="nx-page-body">
        <div className="nx-sector-list">
          {sectors.map((sector) => (
            <Link to="/survey/" key={sector.id} className="nx-sector-row">
              <span className="nx-sector-n">{sector.id}</span>
              <span className="nx-sector-body">
                <h3>{sector.title}</h3>
                <p>{sector.description}</p>
              </span>
              <span className="nx-sector-arrow" aria-hidden="true">→</span>
            </Link>
          ))}
        </div>

        <div className="nx-page-cta">
          <div>
            <h2>Received service in one of these sectors?</h2>
            <p>Three minutes. Anonymous. Added to the national record.</p>
          </div>
          <Link to="/survey/" className="nx-btn nx-btn-primary">Take the survey</Link>
        </div>
      </section>

      <WebsiteFooter />
    </div>
  );
};

export default WebsiteSectors;
